import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useLocation, useMatch } from "react-router-dom"

import { useAppDispatch } from "redux/hooks"
import { openDialog } from "redux/features/dialog/dialogSlice"
import { Content } from "pages/dashboard/elements"
import ProfileNavigation from "components/Layout/ProfileNavigation"
import Title from "components/ui/Title"
import Subscriptions from "components/Subscriptions/List"
import {
  SUBSCRIPTION_CREATE_MATCH,
  SUBSCRIPTION_SUCCESS_MATCH,
  SUBSCRIPTION_FAILURE_MATCH,
  SUBSCRIPTION_SUCCESS_MODAL,
  SUBSCRIPTION_FAILURE_MODAL,
  SUBSCRIPTION_CREATE_MODAL,
  SUBSCRIPTION_UPGRADE_MATCH,
  SUBSCRIPTION_CANCEL_MATCH,
  SUBSCRIPTION_PAY_MATCH,
  SUBSCRIPTION_UPGRADE_MODAL,
  SUBSCRIPTION_CANCEL_MODAL,
  SUBSCRIPTION_BANK_MODAL,
} from "config"

const SubscriptionPage = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const { t } = useTranslation()

  const subscriptionNewMatch = useMatch(SUBSCRIPTION_CREATE_MATCH)
  const subscriptionUpgradeMatch = useMatch(SUBSCRIPTION_UPGRADE_MATCH)
  const subscriptionCancelMatch = useMatch(SUBSCRIPTION_CANCEL_MATCH)
  const subscriptionPayMatch = useMatch(SUBSCRIPTION_PAY_MATCH)
  const subscriptionSuccessMatch = useMatch(SUBSCRIPTION_SUCCESS_MATCH)
  const subscriptionFailureMatch = useMatch(SUBSCRIPTION_FAILURE_MATCH)

  const openCreateSubscriptionModal = () => {
    dispatch(openDialog({ type: SUBSCRIPTION_CREATE_MODAL }))
  }

  const openUpgradeSubscriptionModal = () => {
    dispatch(
      openDialog({
        type: SUBSCRIPTION_UPGRADE_MODAL,
        content: {
          subscriptionId: subscriptionUpgradeMatch?.params["id"],
        },
      }),
    )
  }

  const openCancelSubscriptionModal = () => {
    dispatch(
      openDialog({
        type: SUBSCRIPTION_CANCEL_MODAL,
        content: {
          subscriptionId: subscriptionCancelMatch?.params["id"],
        },
      }),
    )
  }

  const openPaySubscriptionModal = () => {
    dispatch(
      openDialog({
        type: SUBSCRIPTION_BANK_MODAL,
        content: {
          subscriptionId: subscriptionPayMatch?.params["id"],
        },
      }),
    )
  }

  useEffect(() => {
    if (subscriptionNewMatch) {
      openCreateSubscriptionModal()
    } else if (subscriptionUpgradeMatch) {
      openUpgradeSubscriptionModal()
    } else if (subscriptionCancelMatch) {
      openCancelSubscriptionModal()
    } else if (subscriptionPayMatch) {
      openPaySubscriptionModal()
    } else if (subscriptionSuccessMatch) {
      dispatch(openDialog({ type: SUBSCRIPTION_SUCCESS_MODAL }))
    } else if (subscriptionFailureMatch) {
      dispatch(openDialog({ type: SUBSCRIPTION_FAILURE_MODAL }))
    }
  }, [location])

  return (
    <Content data-testid="subscription-page">
      <Title>{t("pages.subscription.title")}</Title>
      <ProfileNavigation />
      <Subscriptions />
    </Content>
  )
}

export default SubscriptionPage
